export const activeVendorsAdd = id => ({
  type: 'ACTIVE_VENDORS_ADD',
  payload: id
})

export const activeVendorsDelete = id => ({
  type: 'ACTIVE_VENDORS_DELETE',
  payload: id
})
